import {Injectable} from "@angular/core";
import {DataLayerModel} from '../models/data-layer.model';
import {GtmAbstractService} from "./gtm.abstract.service";

declare const window: {
	dataLayer: unknown[];
} & Window;

@Injectable({
	providedIn: "root"
})
export class GtmService extends GtmAbstractService {

	public pushToDataLayer(event: object): void {
		this.dataLayer.push(event);
	}

	public pushEventToDataLayer(dataLayerModel: DataLayerModel): void {
		this.pushToDataLayer(dataLayerModel);
	}

	public pushMultipleEventsToDataLayer(dataLayerModels: DataLayerModel[]): void {
		dataLayerModels.forEach((dataLayerModel) => {
			this.pushToDataLayer(dataLayerModel);
		});
	}

	private get dataLayer(): unknown[] {
		window.dataLayer = window.dataLayer || [];
		return window.dataLayer || [];
	}
}